import script from "./buildVersionsMiddle.vue?vue&type=script&setup=true&lang=ts"
export * from "./buildVersionsMiddle.vue?vue&type=script&setup=true&lang=ts"

import "./buildVersionsMiddle.vue?vue&type=style&index=0&id=38ebaf98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38ebaf98"]])

export default __exports__